import { reduceMotion } from '@js/animations/ReducedMotion'
import { createOnceOnEnter } from '@js/animations/scrollTriggerHelper'

export class Mask {
  constructor () {
    this._elements = document.querySelectorAll('[animation-mask]')

    if (!this._elements.length) {
      return
    }

    this.init()
  }

  init () {
    this._elements.forEach((el) => {
      if (reduceMotion) {
        el.classList.add('animation-mask--active')
        return
      }

      createOnceOnEnter({
        trigger: el,
        onEnter: () => {
          el.classList.add('animation-mask--active')
        },
      })
    })
  }
}
